import { css } from '@emotion/react'
import { ExternalStyles, Heading, HeadingProps, HFlow, Text, Theme, useTheme } from 'bold-ui'
import { Box } from 'components/Box'
import { SimNaoEnum } from 'components/form'
import { SimNaoSwitchButtonField } from 'components/form/field/SimNaoSwitchButtonField'
import { isUndefinedOrNull } from 'util/checks'
import { MetaPath } from 'util/metaPath'

interface SimNaoSwitchButtonBoxFieldProps {
  name: MetaPath<SimNaoEnum>
  label: string
  required?: boolean
  headingLevel?: HeadingProps['level']
  style?: ExternalStyles
  labelStyle?: ExternalStyles
}

export function SimNaoSwitchButtonBoxField(props: Readonly<SimNaoSwitchButtonBoxFieldProps>) {
  const { name, label, required, headingLevel, style, labelStyle } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const isHeading = !isUndefinedOrNull(headingLevel)

  return (
    <Box style={style}>
      <HFlow hSpacing={2} alignItems='center' justifyContent='space-between'>
        <HFlow hSpacing={0.25} alignItems='baseline'>
          {isHeading ? (
            <Heading level={headingLevel} style={labelStyle}>
              {label}
              {required && <span css={styles.required}> *</span>}
            </Heading>
          ) : (
            <Text fontWeight='bold' style={labelStyle}>
              {label}
              {required && <span css={styles.required}> *</span>}
            </Text>
          )}
        </HFlow>
        <SimNaoSwitchButtonField name={name} />
      </HFlow>
    </Box>
  )
}

const createStyles = (theme: Theme) => ({
  required: css`
    color: ${theme.pallete.status.danger.main};
  `,
})
